const E = {
  Privacy: 'Privacy',
  'Maxxam 2013 All rights reserved&#46; Success Through Science': 'Bureau Veritas. All rights reserved.',
  'Terms and Conditions': 'Terms and Conditions',
};

const F = {
  Privacy: 'Confidentialité',
  'Maxxam 2013 All rights reserved&#46; Success Through Science': 'Bureau Veritas Tous droits réservés',
  'Terms and Conditions': 'Conditions générales',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/footer.js